import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { PermissionKey } from '../../lib/rbac/permissions.generated';
import { usePermissions } from './use-permission';

interface RequirePermissionProps {
  /** Mindestens einer der Keys genügt; eine leere Liste lässt niemanden durch. */
  anyOf: readonly PermissionKey[];
  children: React.ReactNode;
}

const Loading = () => (
  <div className="flex h-full min-h-[40vh] w-full items-center justify-center" role="status" aria-label="Berechtigungen werden geladen">
    <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
  </div>
);

/**
 * Seiten-Guard: ohne passende Permission geht es auf „Kein Zugriff“. Das ist
 * Ausblenden, keine Sicherheitsgrenze — die Daten schützt das Backend.
 */
export const RequirePermission = ({ anyOf, children }: RequirePermissionProps) => {
  const { status, canAny } = usePermissions();
  const location = useLocation();
  if (status === 'loading') return <Loading />;
  if (status !== 'ready' || !canAny(anyOf)) {
    return <Navigate to="/kein-zugriff" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
};
